import { createEmptyState } from 'data/createRandomState';
import {
  KPI_ADD_UPDATE,
  KPI_REMOVE,
  ADD_KPI_GROUP,
  REMOVE_KPI_GROUP,
  EDIT_KPI_GROUP,
  MOVE_KPI_GROUP_UP,
  MOVE_KPI_GROUP_DOWN,
  MOVE_KPI_UP,
  MOVE_KPI_DOWN,
} from 'constants/actionTypes';
import {
  addUpdateKpiEntry,
  removeKpiEntry,
  addKpiGroup,
  removeKpiGroup,
  editKpiGroup,
  moveKpiGroupUp,
  moveKpiGroupDown,
  moveKpiUp,
  moveKpiDown,
} from 'utils/stateToState';

export default function kpi(state = createEmptyState().kpi, action) {
  switch (action.type) {
    case KPI_ADD_UPDATE: {
      const { kpiEntry } = action;
      return addUpdateKpiEntry(state, kpiEntry);
    }
    case KPI_REMOVE: {
      const { kpiId } = action;
      return removeKpiEntry(state, kpiId);
    }
    case ADD_KPI_GROUP: {
      return addKpiGroup(state);
    }
    case REMOVE_KPI_GROUP: {
      const { groupId } = action;
      return removeKpiGroup(state, groupId);
    }
    case EDIT_KPI_GROUP: {
      const { group } = action;
      return editKpiGroup(state, group);
    }
    case MOVE_KPI_GROUP_UP: {
      const { groupId } = action;
      return moveKpiGroupUp(state, groupId);
    }
    case MOVE_KPI_GROUP_DOWN: {
      const { groupId } = action;
      return moveKpiGroupDown(state, groupId);
    }
    case MOVE_KPI_UP: {
      const { kpiId } = action;
      return moveKpiUp(state, kpiId);
    }
    case MOVE_KPI_DOWN: {
      const { kpiId } = action;
      return moveKpiDown(state, kpiId);
    }
    default:
      return state;
  }
}
